import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import axios from 'axios';

export const defaultNavigationLinks = [
  { id: 'home', label: 'Home', path: '/' },
  {
    id: 'services',
    label: 'Our Practices',
    path: '/services',
    type: 'services',
  },
  { id: 'about', label: 'About Us', path: '/about' },
  { id: 'publications', label: 'Publications', path: '/publications' },
  { id: 'news', label: 'News', path: '/news' },
  { id: 'contact', label: 'Contact Us', path: '/contact' },
];

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const NavigationConfigContext = createContext(null);

export function NavigationConfigProvider({ children }) {
  const [links, setLinks] = useState(defaultNavigationLinks);

  useEffect(() => {
    const fetchNavigation = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/navigation`);
        if (Array.isArray(response.data?.links)) {
          setLinks(response.data.links);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    };

    fetchNavigation();
  }, []);

  const value = useMemo(
    () => ({
      links,
      setLinks,
      resetLinks: () => setLinks(defaultNavigationLinks),
    }),
    [links]
  );

  return (
    <NavigationConfigContext.Provider value={value}>
      {children}
    </NavigationConfigContext.Provider>
  );
}

export function useNavigationConfig() {
  const ctx = useContext(NavigationConfigContext);
  if (!ctx) {
    throw new Error('useNavigationConfig must be used within NavigationConfigProvider');
  }
  return ctx;
}

